/**
 * A cycle's state as the prototype draws it (f10.2).
 *
 * Presentation only: the state code and its display name both come from the
 * server's `cycle_state` lookup. An unknown code -- a value an Admin added as a
 * row -- falls back to the neutral pill rather than failing.
 */

const PILL_BY_STATE: Readonly<Record<string, string>> = {
  DRAFT: 'pill-pending',
  PREPARED: 'pill-neutral',
  OPEN_FOR_INPUT: 'pill-info',
  IN_REVIEW: 'pill-admin',
  FROZEN: 'pill-warning',
  SUBMITTED: 'pill-neutral',
};

export function cycleStatePillClass(code: string): string {
  return `badge ${PILL_BY_STATE[code] ?? 'pill-neutral'}`;
}

export function CycleStateBadge({ state }: { state: { code: string; name: string } }) {
  return (
    <span className={cycleStatePillClass(state.code)}>
      {state.code === 'OPEN_FOR_INPUT' && <span className="cycle-live-dot" aria-hidden="true" />}
      {state.name}
    </span>
  );
}
